var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.539,
    height: 29,
    viewBox: "0 0 24.539 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2753",
    "data-name": "\\uADF8\\uB8F9 2753",
    transform: "translate(-783 -281.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1142",
    "data-name": "\\uC0AC\\uAC01\\uD615 1142",
    d: "M4,3A1,1,0,0,0,3,4V25a1,1,0,0,0,1,1H20.538a1,1,0,0,0,1-1V4a1,1,0,0,0-1-1H4M4,0H20.538a4,4,0,0,1,4,4V25a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(783 281.783)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1143",
    "data-name": "\\uC0AC\\uAC01\\uD615 1143",
    width: 3,
    height: 13,
    transform: "translate(798.077 293.096)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1144",
    "data-name": "\\uC0AC\\uAC01\\uD615 1144",
    width: 3,
    height: 17.754,
    transform: "translate(793.769 288.342)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1145",
    "data-name": "\\uC0AC\\uAC01\\uD615 1145",
    width: 3,
    height: 7.211,
    transform: "translate(789.462 298.885)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.3ed2c5b84c4d8cc68dea099d6a8a9060.svg";
export { ForwardRef as ReactComponent };